<template>
    <v-card class="smart-view-dialogue-base" flat>
        <div class="smart-view-dialogue-base__header">
            <div class="smart-view-dialogue-base__heading">
                <slot name="heading" />
            </div>
            <v-btn
                icon
                variant="text"
                class="smart-view-dialogue-base__close"
                @click="close"
            >
                <v-icon>$vuetify.icons.close</v-icon>
            </v-btn>
        </div>
        <div class="smart-view-dialogue-base__content">
            <slot name="content" />
        </div>
    </v-card>
</template>

<script>
/**
 * Use this base component for any dialogues rendered in smartview
 */
export default {
    name: 'SmartViewDialogueBase',
    props: {
        close: {
            type: Function,
            default() {
                this.$emit('close-dialog');
            },
        },
    },
};
</script>
